import React from 'react';
import { Typography as MUITypography } from '@material-ui/core';
import type { TypographyProps } from '@material-ui/core/Typography';
import type { KlpHeadingLevel, KlpStyled } from '../Theme';
import { removeKlpStyles } from '../Theme';
import type { WithTranslation } from '../TranslationOrChildren';
import { TranslationOrChildren } from '../TranslationOrChildren';
import { useKlpStyles } from '../Theme/useKlpStyles';
import classNames from 'classnames';

export enum HeadingMapping {
    ONE = 'h1',
    TWO = 'h2',
    THREE = 'h3',
    FOUR = 'h4',
    FIVE = 'h5',
    SIX = 'h6',
}

type HeadingProps = Partial<KlpStyled> &
    Partial<TypographyProps> &
    WithTranslation & { klpHeadingLevel?: KlpHeadingLevel };

export const Heading: React.FC<HeadingProps> = ({
    children,
    className = '',
    klpHeadingLevel = 'TWO',
    translation,
    translationOptions,
    ...restProps
}) => {
    const styles = useKlpStyles(restProps);
    return (
        <MUITypography
            variant={HeadingMapping[klpHeadingLevel]}
            className={classNames(styles.klpStyles, className)}
            data-testid="Heading"
            {...removeKlpStyles(restProps)}
        >
            <TranslationOrChildren
                translation={translation}
                translationOptions={translationOptions}
            >
                {children}
            </TranslationOrChildren>
        </MUITypography>
    );
};

Heading.defaultProps = {
    klpHeadingLevel: 'TWO',
};
